import {
    initClient,
    extendPrivateKey,
    extendFromObject,
    extendFromMnemonic
} from '@/wallet/bcw.js'

var _ = require('lodash')

/**
 * 生成一个新的秘钥信息
 */
export function extendNewPrivateKey() {
    return extendPrivateKey()
}

/**
 * 使用现有key生成
 */
export function extendKeyFromObject(key) {
    return extendFromObject(key)
}

/**
 * 创建一个身份
 */
export function createCredentials(ireneKeys, ismulti) {
    return ireneKeys.createCredentials(null, {
        coin: 'vcl',
        network: 'livenet',
        account: 0,
        n: ismulti ? 2 : 1,
        addressType: 'P2PKH'
    })
}

/**
 * 导入账户
 */
export function importWallet(credentials) {
    return new Promise((resolve, reject) => {
        var client = initClient(null, null)
        client.fromObj(credentials)
        client.openWallet(orr => {
            if (orr) {
                return reject('打开钱包失败:', orr)
            }
            if (!client.isComplete()) return reject('账户初始化中')
            client.credentials.mnemonic = credentials.mnemonic
            client.credentials.mnemonicHasPassphrase =
        credentials.mnemonicHasPassphrase
            return resolve(client.credentials)
        })
    })
}

/**
 * 创建一个标准钱包
 * @param {Object} opts
 */
export function doCreateWallet(name, credentials) {
    return new Promise((resolve, reject) => {
        var client = initClient(null, null)
        client.fromObj(credentials)
        console.log('标准钱包')
        client.createWallet(
            name,
            name,
            1,
            1,
            {
                network: 'livenet',
                singleAddress: process.env.singleAddress
            },
            err => {
                if (err) {
                    console.log('create wallet error: ', err)
                    return reject(err)
                }
                client.credentials.mnemonic = credentials.mnemonic
                client.credentials.mnemonicHasPassphrase =
          credentials.mnemonicHasPassphrase
                return resolve(client.credentials)
            }
        )
    })
}

/**
 * 创建一个多签钱包
 */
export function doCreateMultiWallet(name, credentials, m, n) {
    return new Promise((resolve, reject) => {
        var client = initClient(null, null)
        client.fromObj(credentials)
        m = Number(m)
        n = Number(n)
        client.createWallet(
            name,
            name,
            m,
            n,
            {
                network: 'livenet'
            },
            (err, secret) => {
                if (err) {
                    console.log('create wallet error: ', err)
                    return reject(err)
                }

                client.credentials.mnemonic = credentials.mnemonic
                client.credentials.mnemonicHasPassphrase =
          credentials.mnemonicHasPassphrase
                client.credentials.multiSecret = secret
                return resolve(client.credentials)
            }
        )
    })
}

/**
 * 加入到一个多签钱包
 */
export function doJoinMultiWallet(secret, name, credentials) {
    return new Promise((resolve, reject) => {
        var client = initClient(null, null)
        client.fromObj(credentials)
        client.joinWallet(secret, name, { coin: 'vcl' }, err => {
            if (err) {
                console.error(err)
                return reject(err)
            } else {
                client.credentials.mnemonic = credentials.mnemonic
                client.credentials.mnemonicHasPassphrase =
          credentials.mnemonicHasPassphrase
                client.credentials.multiSecret = secret
                return resolve(client.credentials)
            }
        })
    })
}

/**
 * 使用助记词生成身份信息
 * @param {Object} words
 */
export function importMnemonic(words) {
    const keys = extendFromMnemonic(words)
    return keys
}

/**
 * 打开一个钱包
 */
export function openWallet(credentials) {
    var client = initClient(null, null)
    client.fromObj(credentials)
    return client
}

/**
 * 创建一个新地址
 * @param {Object} wallet
 * @param {Object} opts
 */
export function createAddress(wallet, opts) {
    return new Promise((resolve, reject) => {
        wallet.keyId = wallet.credentials.keyId
        console.log('账户创建地址:', wallet.keyId)
        opts = opts || {}
        wallet.createAddress(opts, (err, addr) => {
            if (err) {
                if (err.message && err.message == 'MAIN_ADDRESS_GAP_REACHED') {
                    wallet.getMainAddresses(
                        {
                            reverse: true,
                            limit: 1
                        },
                        (err, addr) => {
                            if (err) reject(err)
                            resolve(addr[0].address)
                        }
                    )
                } else {
                    reject(err)
                }
            } else resolve(addr.address)
        })
    })
}

/** 1.发布交易
 * @param {Object} wallet
 * @param {Object} txp
 */
export function publishTx(wallet, txp) {
    return new Promise((resolve, reject) => {
        if (_.isEmpty(txp) || _.isEmpty(wallet)) return reject('MISSING_PARAMETER')
        wallet.publishTxProposal(
            {
                txp
            },
            (err, publishedTx) => {
                if (err) return reject(err)
                else {
                    console.log('Transaction published')
                    return resolve(publishedTx)
                }
            }
        )
    })
}

/** 2.交易签名
 * @param {Object} client
 * @param {Object} txp
 */
export function signTx(client, txp) {
    return new Promise((resolve, reject) => {
        if (!client || !txp) return reject('MISSING_PARAMETER')
        const key = extendFromMnemonic(client.credentials.mnemonic)
        console.log('key:', key)
        const signatures = key.sign(client.getRootPath(), txp)
        client.pushSignatures(txp, signatures, (err, xx) => {
            if (err) {
                return reject(err)
            }
            return resolve(xx)
        })
    })
}

/** 3.广播交易
 * @param {Object} wallet
 * @param {Object} txp
 */
export function broadcastTx(wallet, txp) {
    return new Promise((resolve, reject) => {
        if (_.isEmpty(txp) || _.isEmpty(wallet)) return reject('MISSING_PARAMETER')

        if (txp.status != 'accepted') return reject('TX_NOT_ACCEPTED')

        wallet.broadcastTxProposal(txp, (err, broadcastedTxp, memo) => {
            if (err) {
                removeTx(wallet, txp)
                return reject(err)
            }

            console.log('Transaction broadcasted')
            if (memo) console.log('Memo: ', memo)

            return resolve(broadcastedTxp)
        })
    })
}

/** 删除交易
 * @param {Object} wallet
 * @param {Object} txp
 */
export function removeTx(wallet, txp) {
    return new Promise((resolve, reject) => {
        if (_.isEmpty(txp) || _.isEmpty(wallet)) return reject('MISSING_PARAMETER')

        wallet.removeTxProposal(txp, err => {
            console.log('Transaction removed')
            return resolve(err)
        })
    })
}



// WEBPACK FOOTER //
// ./src/wallet/bcw_api.js